import React from "react";
import { Accordion } from "react-bootstrap";

const FloraTab = () => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="tab-content" id="collapseThree">
          <Accordion.Body className="height_set">
            <div className="about_content">
              <p></p>
              <p>
                <br />
                <strong>Flora</strong>
              </p>
              <p>
                <br />
                Southern tropical moist deciduous forest, Southern tropical dry
                deciduous forest, Tropical riparian fringing forest, southern
                tropical thorn forest, central Indian sun tropical hill forest,
                Dry and moist grassland. In general the forest ranges from Sal
                forest on Pachmarhi plateau and mixed forest in most of the
                areas, with some patches of teak forest.
              </p>
              <p>
                <br />
                <strong>Fauna</strong>
              </p>
              <p>
                <br />
                Faunal diversity is tremendous and includes threatened and
                critically endangered species. Tiger is the charismatic species
                along with other mammals like Gaur, Sambar, Chital, besides co
                predators, birds, reptiles and fishes.
              </p>
              <p></p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default FloraTab;
